import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { formatarPreco, emOferta } from '../data/produtos';

export default function ProductCard({ produto, index, onDetalhes, onWhatsApp }) {
  return (
    <motion.article
      data-testid={`product-card-${produto.id}`}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-30px' }}
      transition={{ duration: 0.55, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
      className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-xl"
    >
      <div className="relative">
        {produto.esgotado ? (
          <span
            data-testid={`product-card-badge-${produto.id}`}
            className="absolute left-2.5 top-2.5 z-10 rounded-full bg-slate-700 px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white shadow-lg"
          >
            Esgotado
          </span>
        ) : (
          emOferta(produto) && (
            <span
              data-testid={`product-card-badge-${produto.id}`}
              className="absolute left-2.5 top-2.5 z-10 rounded-full bg-mk-red px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white shadow-lg shadow-mk-red/40"
            >
              Oferta
            </span>
          )
        )}
        <button
          data-testid={`product-card-image-${produto.id}`}
          onClick={() => onDetalhes(produto)}
          className="block w-full overflow-hidden bg-slate-50"
          aria-label={`Ver detalhes de ${produto.nome}`}
        >
          <img
            src={produto.imagem}
            alt={produto.nome}
            loading="lazy"
            decoding="async"
            className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-[1.06]"
          />
        </button>
      </div>
      <div className="flex flex-1 flex-col p-3 sm:p-4">
        {produto.marca && (
          <p className="text-[10px] sm:text-[11px] font-extrabold uppercase tracking-[0.15em] text-mk-blue">{produto.marca}</p>
        )}
        <h3
          data-testid={`product-card-title-${produto.id}`}
          className="mt-1 min-h-[2.4rem] sm:min-h-[2.7rem] font-heading text-sm sm:text-base font-bold leading-snug text-slate-900 line-clamp-2"
        >
          {produto.nome}
        </h3>
        {produto.parcelas && (
          <p className="mt-2 text-[11px] sm:text-xs font-medium text-slate-500">
            {produto.parcelas.vezes}x de {formatarPreco(produto.parcelas.valor)}
          </p>
        )}
        {produto.precoDe && (
          <p className="mt-1 text-xs font-medium text-slate-400 line-through">
            de {formatarPreco(produto.precoDe)}
          </p>
        )}
        <p className="mt-1 flex items-baseline gap-2">
          <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">à vista</span>
          <span data-testid={`product-card-price-${produto.id}`} className="font-heading text-lg sm:text-2xl font-black tracking-tight text-mk-red">
            {formatarPreco(produto.preco)}
          </span>
        </p>
        {produto.estoqueExibido != null && (
          <p data-testid={`product-card-stock-${produto.id}`} className="mt-1 text-xs font-bold text-mk-blue">
            {produto.estoqueExibido} unidades em estoque
          </p>
        )}
        <div className="mt-3 sm:mt-4 flex gap-2">
          <button
            data-testid={`product-card-details-button-${produto.id}`}
            onClick={() => onDetalhes(produto)}
            className="min-h-[44px] flex-1 rounded-full border-2 border-mk-blue px-2 sm:px-3 py-2 text-xs sm:text-sm font-bold text-mk-blue transition-colors duration-300 hover:bg-mk-blue hover:text-white"
          >
            Ver detalhes
          </button>
          <button
            data-testid={`product-card-whatsapp-button-${produto.id}`}
            onClick={() => onWhatsApp(produto)}
            aria-label={`Consultar ${produto.nome} pelo WhatsApp`}
            className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full bg-mk-green p-2.5 text-white shadow-md shadow-mk-green/30 transition-colors duration-300 hover:bg-mk-greendark"
          >
            <MessageCircle size={19} strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </motion.article>
  );
}
